<div class="multipoint-modal-error-endpoints__container-title">
  <h2>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.ERROR_CALLS_BACK' | i18nextEager }}</h2>
  <img src="/assets/icons/close.svg" alt="{{ 'COMMONS.CANCEL' | i18nextEager }}" (click)="closeModal()" />
</div>
<div class="multipoint-modal-error-endpoints__container">
  <div *ngIf="dataDialog.errorTensionCyclePeriod" class="multipoint-modal-error-endpoints__container-items">
    <p>
      <strong>{{ 'NEW_CONTRACTS.ROAD_TYPE' | i18nextEager }}: </strong>
      {{ dataDialog.errorTensionCyclePeriod }}
    </p>
  </div>
  <div *ngIf="dataDialog.errorRoadType" class="multipoint-modal-error-endpoints__container-items">
    <p>
      <strong>{{ 'NEW_CONTRACTS.ROAD_TYPE' | i18nextEager }}: </strong>
      {{ dataDialog.errorRoadType }}
    </p>
  </div>
  <div
    *ngFor="let item of dataDialog.installations; let i = index"
    class="multipoint-modal-error-endpoints__container-items"
  >
    <ng-container
      *ngIf="item.errorCups || item.errorRepeatCups || item.errorAddressInstallation || item.errorAddressNotification"
    >
      <div
        class="multipoint-modal-error-endpoints__container-items multipoint-modal-error-endpoints__container-items--no-wrap"
      >
        <span class="multipoint-modal-error-endpoints__circle"></span>
        <p>
          <strong *ngIf="item.name">{{ item.name }}</strong>
          <strong *ngIf="!item.name">
            {{ 'NEW_CONTRACTS.INSTALLATION_DATA.INSTALLATION' | i18nextEager }} {{ i + 1 }}
          </strong>
        </p>
      </div>
      <div class="multipoint-modal-error-endpoints__container-items">
        <div
          *ngIf="item.errorCups"
          class="multipoint-modal-error-endpoints__container-items multipoint-modal-error-endpoints__container-items--no-wrap"
        >
          <span class="multipoint-modal-error-endpoints__circle multipoint-modal-error-endpoints__circle--minor"></span>
          <p>{{ item.errorCups }}</p>
        </div>
        <div
          *ngIf="item.errorRepeatCups"
          class="multipoint-modal-error-endpoints__container-items multipoint-modal-error-endpoints__container-items--no-wrap"
        >
          <span class="multipoint-modal-error-endpoints__circle multipoint-modal-error-endpoints__circle--minor"></span>
          <p>{{ item.errorRepeatCups }}</p>
        </div>
        <div
          *ngIf="item.errorAddressInstallation"
          class="multipoint-modal-error-endpoints__container-items multipoint-modal-error-endpoints__container-items--no-wrap"
        >
          <span class="multipoint-modal-error-endpoints__circle multipoint-modal-error-endpoints__circle--minor"></span>
          <p>{{ item.errorAddressInstallation }}</p>
        </div>
        <div
          *ngIf="item.errorAddressNotification"
          class="multipoint-modal-error-endpoints__container-items multipoint-modal-error-endpoints__container-items--no-wrap"
        >
          <span class="multipoint-modal-error-endpoints__circle multipoint-modal-error-endpoints__circle--minor"></span>
          <p>{{ item.errorAddressNotification }}</p>
        </div>
      </div>
    </ng-container>
  </div>
</div>
